
import { mapActions, mapState, mapMutations } from "vuex";

import CommonInfoDialog from "../dialogs/common-info-dialog.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import menuUploadGridItemAvatarName from "./menu-upload-grid-item-avatar-name.vue";
export default {
  components: {
    menuUploadGridItemAvatarName,
    CommonInfoDialog,
    ConfirmationDialog
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isEditing: false,
      newDescription: "",
      maxCharacters: 150,
      showDescriptionPendingDialog: false
    };
  },
  beforeMount() {
    this.newDescription = this.item.description;
  },
  watch: {
    menuUploadList: {
      handler(val) {
        if (val) {
          this.newDescription = this.item.description;
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState("menu", ["menuUploadList"]),
    remainingCharacters() {
      return this.maxCharacters - (this.newDescription?.length || 0);
    }
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),
    updateDescription() {
      const index = this.getMenuUploadItemIndex(
        this.menuUploadList,
        this.item.id
      );

      if (index !== -1) {
        this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
          index: index,
          propName: "description",
          propValue: this.newDescription
        });
      }
      this.$nuxt.$emit("reapply-filter");
    },
    focusInputAfterDialog() {
      this.$nextTick(() => {
        this.$refs.descriptionInput.focus();
      });
    },
    saveDescription() {
      const description = this.newDescription.toLowerCase();
      const itemName = this.item.item_name.toLowerCase();
      if (description === itemName) {
        this.$nuxt.$emit("show-info-dialog", {
          content: "Item name and description cannot be the same.",
          callbackOnClose: () => this.focusInputAfterDialog()
        });
        return;
      }

      if (this.newDescription.length < 10) {
        this.$nuxt.$emit("show-info-dialog", {
          content: "Description must be at least 10 characters long.",
          callbackOnClose: () => this.focusInputAfterDialog()
        });
        return;
      }
      this.updateDescription();
      this.isEditing = false;
    },
    cancelEdit() {
      this.newDescription = "";
      this.updateDescription();
      this.isEditing = false;
    },
    updateCharacterCount() {
      if (this.newDescription.length > this.maxCharacters) {
        this.newDescription = this.newDescription.slice(0, this.maxCharacters);
      }
    },
    handleShowDescriptionPendingDialog(e) {
      if (
        this.newDescription ||
        (this.item.description && !this.newDescription)
      ) {
        if (
          e?.relatedTarget?.__vue__?._uid ===
            this.$refs?.save_description?._uid ||
          e?.relatedTarget?.__vue__?._uid ===
            this.$refs?.cancel_description?._uid
        ) {
          this.showDescriptionPendingDialog = false;
        } else {
          this.showDescriptionPendingDialog = true;
        }
      } else {
        this.isEditing = false;
      }
    },
    handleSaveDescription() {
      this.saveDescription();
      this.showDescriptionPendingDialog = false;
    },
    handleDiscardDescription() {
      this.cancelEdit();
      this.showDescriptionPendingDialog = false;
    }
  }
};
